import React, { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { formatDistanceToNow } from "date-fns";

//facebook-login
import FacebookLogin from "@greatsumini/react-facebook-login";

//MUI
import styled from "@emotion/styled";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Badge from "@mui/material/Badge";
import Popover from "@mui/material/Popover";

//context
import { AuthContext } from "../../contexts/AuthContext";
import { DataContext } from "../../contexts/DataContext";

//helpers
import { matchPath } from "../../utils/helpers";

//assets
// import { ReactComponent as ContentLogo } from "../../assets/content_logo.svg";
import { ReactComponent as WorkBoardIcon } from "../../assets/work_board.svg";
import { ReactComponent as WorkBoardColIcon } from "../../assets/work_board_col.svg";
// import { ReactComponent as TaskManagementIcon } from "../../assets/task.svg";
// import { ReactComponent as TaskManagementColIcon } from "../../assets/task_management_col.svg";
// import { ReactComponent as TaskListIcon } from "../../assets/task_list.svg";
// import { ReactComponent as TaskListColIcon } from "../../assets/task_list_col.svg";
// import { ReactComponent as VideoIcon } from "../../assets/video_icon1.svg";
import { ReactComponent as DashboardIcon } from "../../assets/dashboard.svg";
import { ReactComponent as DashboardColIcon } from "../../assets/dashboard_col.svg";
import { ReactComponent as UserIcon } from "../../assets/user_icon.svg";
import { ReactComponent as UserColIcon } from "../../assets/user_icon_col.svg";
import { ReactComponent as PostsColIcon } from "../../assets/posts_icon_col.svg";
import { ReactComponent as PostsIcon } from "../../assets/posts_icon.svg";
import { ReactComponent as FacebookIcon } from "../../assets/facebook_icon.svg";
import { ReactComponent as RepoSitoryIcon } from "../../assets/repository_icon.svg";
import { ReactComponent as RepoSitoryColIcon } from "../../assets/repository_icon_col.svg";


import ContentLogo from "../../assets/images/logo.png";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import RefreshIcon from "@mui/icons-material/Refresh";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

//components
import CustomButton from "../Common/CustomButton";

//apis
import {
  getUserInfo,
  getLongUserToken,
  submitFBTokens,
} from "../../apis/facebookAuth";

const pages = [
  // {
  //   name: "Content",
  //   key: "content",
  //   icon: ContentIcon,
  // },
  // {
  //   name: "Videos",
  //   key: "videos",
  //   icon: VideoIcon,
  // },
  {
    name: "Work Board",
    key: "work_board",
    icon: WorkBoardIcon,
    colIcon: WorkBoardColIcon,
  },
  // {
  //   name: "Task Management",
  //   key: "task_manage",
  //   icon: TaskManagementIcon,
  //   colIcon: TaskManagementColIcon,
  // },
  // {
  //   name: "Task List",
  //   key: "task_list",
  //   icon: TaskListIcon,
  //   colIcon: TaskListColIcon,
  // },
  {
    name: "Dashboard",
    key: "dashboard",
    icon: DashboardIcon,
    colIcon: DashboardColIcon,
  },
  {
    name: "Posts",
    key: "posts",
    icon: PostsIcon,
    colIcon: PostsColIcon,
  },
  {
    name: "Library",
    key: "repository",
    icon: RepoSitoryIcon,
    colIcon: RepoSitoryColIcon,
  },
  {
    name: "User List",
    key: "users",
    icon: UserIcon,
    colIcon: UserColIcon,
  },
  // {
  //   name: "Explore AI",
  //   key: "explore_ai",
  //   icon: UserIcon,
  //   colIcon: UserColIcon,
  // },
];
const settings = ["Logout"];

const Container = styled("div")(({ theme }) => ({
  background: "#FFFFFF",
  padding: "0 1rem",
  borderBottom: "1px solid #E5E5E5",
  "& .MuiToolbar-root": {
    display: "flex",
    justifyContent: "space-between",
    height: "64px",
    maxHeight: "64px",
    [theme.breakpoints.down("xl")]: {
      minHeight: "56px",
      height: "56px",
      maxHeight: "56px",
    },
    [theme.breakpoints.down("lg")]: {
      minHeight: "48px",
      height: "48px",
      maxHeight: "48px",
    },
  },
  "& .logo_section_container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "9rem",
  },
  "& .logo": {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    "& svg": {
      height: "50px",
      color: "#FFFFFF",
      fill: "#FFFFFF",
      [theme.breakpoints.down("xl")]: {
        height: "35px",
      },
      [theme.breakpoints.down("xl")]: {
        height: "30px",
      },
    },
    "& .logo_style": {
      height: "45px",
      width: "85px",
      [theme.breakpoints.down("xl")]: {
        height: "37px",
        width: "70px",
      },
      [theme.breakpoints.down("lg")]: {
        height: "35px",
        width: "63px",
      },
    },
  },
  "& .box_container": {
    display: "flex",
    gap: "1.2rem",
    alignItems: "center",
    [theme.breakpoints.down("xl")]: {
      gap: "0.5rem",
    },
  },
  "& .link_style": {
    color: "#FFFFFF",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minWidth: "100px",
    "& svg": {
      height: "19px",
      [theme.breakpoints.down("xl")]: {
        height: "18px",
      },
      [theme.breakpoints.down("lg")]: {
        height: "16px",
      },
    },
    "& .text_style": {
      fontSize: "14px",
      letterSpacing: 0.9,
      lineHeight: 1,
      // fontWeight: "400",
      [theme.breakpoints.down("xl")]: {
        fontSize: "12px",
      },
      [theme.breakpoints.down("lg")]: {
        fontSize: "11px",
      },
    },
  },
  "& .MuiAvatar-root": {
    height: "40px",
    width: "40px",
    [theme.breakpoints.down("xl")]: {
      height: "30px",
      width: "30px",
    },
  },
  "& .right-box": {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    "& .MuiPopover-paper": {
      width: 350,
      maxHeight: 400,
      overflowY: "auto",
      bgcolor: "#f7f9fc",
      boxShadow: 3,
      borderRadius: 2,
    },
  },
}));

function ResponsiveAppBar({ setActivateLog }) {
  const [, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [settingsAnchorEl, setSettingsAnchorEl] = useState(null);

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { handleLogOut, user } = useContext(AuthContext);
  const { notifications, unreadCount, clearNotifications } =
    useContext(DataContext);
  const canConfigureSlack =
    user?.is_superuser === true ||
    user?.role?.some((role) => role?.id === 6);
  const [notifAnchorEl, setNotifAnchorEl] = useState(null);

  const handleNotifClick = (event) => {
    setNotifAnchorEl(event.currentTarget);
    clearNotifications();
  };

  const handleNotifClose = () => {
    setNotifAnchorEl(null);
    clearNotifications();
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleSettingsMenuOpen = (event) => {
    setSettingsAnchorEl(event.currentTarget);
  };

  const handleSettingsMenuClose = () => {
    setSettingsAnchorEl(null);
  };

  const handleSettingsNavigation = (path) => {
    handleSettingsMenuClose();
    navigate(path);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    // setActivateLog(true)
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleAction = () => {
    handleLogOut();
  };

  const fetchUserLongToken = async (access_token) => {
    const { data, error } = await getLongUserToken(access_token);
    if (error) {
      console.log("Couldn't fetch the data");
      return;
    }
    return data;
  };

  const fetchPageData = async (initialUrl) => {
    let next = initialUrl;
    let pageData = [];

    try {
      while (next) {
        const response = await fetch(next);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        pageData = [...pageData, ...result.data];
        next =
          result.data.length > 0 && result.paging ? result.paging.next : null;
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }

    return pageData;
  };

  const submitData = async (info) => {
    const { error } = await submitFBTokens(info);
    if (error) {
      console.log("Couldn't fetch the data");
      return;
    }
  };

  const responseFacebook = async (response) => {
    const { data, error } = await getUserInfo(
      response.userID,
      response.accessToken,
    );
    if (error) {
      console.log("Couldn't fetch the data");
      return;
    }
    let longUserToken = await fetchUserLongToken(response.accessToken);
    // setUserInfo({
    //   user_token: longUserToken?.access_token,
    //   user_fb_id: data.id,
    // })
    let initialUrl = `https://graph.facebook.com/v20.0/me/accounts?&access_token=${longUserToken?.access_token}&fields=access_token,name,id,instagram_business_account{id,username,name}&limit=10`;
    await fetchPageData(initialUrl);
    let initialUrlLongPage = `https://graph.facebook.com/v20.0/${data.id}/accounts?access_token=${longUserToken?.access_token}&fields=access_token,name,id,instagram_business_account{id,username,name}&limit=10`;
    const longTokenPageData = await fetchPageData(initialUrlLongPage);
    let completePageData = [];
    longTokenPageData.forEach((item) => {
      let pageObj = {
        page_id: item.id,
        page_token: item.access_token,
      };
      if (item?.instagram_business_account) {
        pageObj[`instagram_business_account`] =
          item?.instagram_business_account;
      }
      completePageData = [...completePageData, pageObj];
    });
    let completeInfo = {
      user_token: {
        user_token: longUserToken?.access_token,
        user_fb_id: data.id,
      },
      page_token: completePageData,
    };
    submitData(completeInfo);
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        height: { md: "48px", lg: "56px", xl: "64px" },
        maxHeight: { md: "48px", lg: "56px", xl: "64px" },
      }}
    >
      <Container>
        <Toolbar disableGutters>
          <div className="logo_section_container">
            <div className="logo">
              {/* <ContentLogo /> */}
              <img src={ContentLogo} className="logo_style" alt="logo_img" />
            </div>

            <div>
              <Box className="box_container">
                {pages.map((page) => {
                  if (page.key === "task_manage" && !user?.is_admin) {
                    return null;
                  } else if (page.key === "dashboard" && !user?.is_staff) {
                    return null;
                  } else {
                    return (
                      <Link key={page.key} to={`/app/${page.key}`}>
                        <CustomButton
                          onClick={handleCloseNavMenu}
                          className="link_style"
                          sx={{
                            textTransform: "none",
                            "&:hover": {
                              background: "none",
                            },
                          }}
                        // sx={{ my: 2, color: 'white', display: 'block' }}
                        >
                          {page?.icon ? (
                            matchPath(pathname, page.key) ? (
                              <page.colIcon />
                            ) : (
                              <page.icon />
                            )
                          ) : (
                            <Box
                              sx={{
                                height: {
                                  md: "19px",
                                  lg: "17.4px",
                                  xl: "17px",
                                },
                              }}
                            ></Box>
                          )}
                          <Typography
                            className="text_style"
                            sx={{
                              color: matchPath(pathname, page.key)
                                ? "#253A6A"
                                : "#4F4F4F",
                              fontWeight: matchPath(pathname, page.key)
                                ? "700"
                                : "400",
                              marginTop: "3px",
                            }}
                          >
                            {page?.name}
                          </Typography>
                        </CustomButton>
                      </Link>
                    );
                  }
                })}
              </Box>
            </div>
          </div>

          <Box className="right-box">
            {canConfigureSlack && (
              <>
                <Tooltip title="Settings">
                  <IconButton
                    id="workspace-settings-button"
                    aria-controls={
                      settingsAnchorEl ? "workspace-settings-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={settingsAnchorEl ? "true" : undefined}
                    onClick={handleSettingsMenuOpen}
                    size="small"
                    sx={{ color: "#253A6A" }}
                  >
                    <SettingsOutlinedIcon sx={{ fontSize: "1.75rem" }} />
                  </IconButton>
                </Tooltip>
                <Menu
                  id="workspace-settings-menu"
                  anchorEl={settingsAnchorEl}
                  open={Boolean(settingsAnchorEl)}
                  onClose={handleSettingsMenuClose}
                  MenuListProps={{
                    "aria-labelledby": "workspace-settings-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  PaperProps={{
                    sx: {
                      mt: 0.75,
                      minWidth: 170,
                    },
                  }}
                >
                  <MenuItem
                    selected={pathname === "/app/work_board/slack_config"}
                    onClick={() =>
                      handleSettingsNavigation("/app/work_board/slack_config")
                    }
                  >
                    Slack Config
                  </MenuItem>
                  <MenuItem
                    selected={pathname === "/app/work_board/link_matching"}
                    onClick={() =>
                      handleSettingsNavigation("/app/work_board/link_matching")
                    }
                  >
                    Link Matching
                  </MenuItem>
                </Menu>
              </>
            )}
            <Badge badgeContent={unreadCount} color="error">
              <NotificationsNoneIcon
                color="primary"
                onClick={handleNotifClick}
                sx={{ fontSize: "1.75rem" }}
              />
            </Badge>
            <Popover
              open={Boolean(notifAnchorEl)}
              anchorEl={notifAnchorEl}
              onClose={handleNotifClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0.75rem 1rem",
                  bgcolor: "primary.main",
                  color: "#fff",
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                  minWidth: 350,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "1.1rem", fontWeight: 700 }}
                >
                  Notifications
                </Typography>
                <CustomButton
                  size="small"
                  variant="outlined"
                  onClick={handleReload}
                  endIcon={<RefreshIcon />}
                  sx={{
                    background: "#fff",
                    "&:hover": {
                      background: "#fff",
                    },
                  }}
                >
                  Refresh Page
                </CustomButton>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  px: 1.5,
                  py: 1,
                  gap: 1,
                  maxHeight: 300,
                  overflowY: "scroll",
                }}
              >
                {notifications.length === 0 ? (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center", mt: 2 }}
                  >
                    No notifications
                  </Typography>
                ) : (
                  notifications.map((notif, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        p: 1,
                        borderRadius: 1,
                        bgcolor: idx === 0 ? "#e3f2fd" : "#fff",
                        boxShadow: idx === 0 ? 1 : 0,
                        border: "1px solid #e0e3e7",
                        transition: "background 0.2s",
                        "&:hover": {
                          background: "#f1f8fe",
                        },
                        maxWidth: 350,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#253A6A",
                          fontWeight: idx === 0 ? 600 : 400,
                        }}
                      >
                        {notif.eventMessage}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {formatDistanceToNow(new Date(notif.timestamp), {
                          addSuffix: true,
                        })}
                      </Typography>
                    </Box>
                  ))
                )}
              </Box>
            </Popover>
            {user && user?.is_superuser ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FacebookLogin
                  appId={process.env.REACT_APP_FB_APP_ID}
                  scope="pages_show_list,business_management,pages_read_engagement,pages_manage_posts,instagram_basic,instagram_content_publish"
                  onSuccess={responseFacebook}
                  style={{
                    backgroundColor: "#ffffff",
                    color: "#fff",
                    border: "none",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "36px",
                    width: "36px",
                  }}
                >
                  <FacebookIcon />
                </FacebookLogin>
              </div>
            ) : (
              <></>
            )}
            <a
              href={`https://slack.com/oauth/v2/authorize?scope=users:read,users:read.email,users.profile:read,channels:read,chat:write&user_scope=&redirect_uri=${process.env.REACT_APP_API_PATH}/oauth&client_id=${process.env.REACT_APP_SLACK_CLIENT_ID}`}
              target="_blank"
              rel="noreferrer"
              referrerPolicy="no-referrer"
              style={{
                alignItems: "center",
                color: "#000",
                backgroundColor: "#fff",
                display: "inline-flex",
                fontFamily: "Lato, sans-serif",
                justifyContent: "center",
                textDecoration: "none",
                width: "30px",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{ height: "22px", width: "22px" }}
                viewBox="0 0 122.8 122.8"
              >
                <path
                  d="M25.8 77.6c0 7.1-5.8 12.9-12.9 12.9S0 84.7 0 77.6s5.8-12.9 12.9-12.9h12.9v12.9zm6.5 0c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9v32.3c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V77.6z"
                  fill="#e01e5a"
                ></path>
                <path
                  d="M45.2 25.8c-7.1 0-12.9-5.8-12.9-12.9S38.1 0 45.2 0s12.9 5.8 12.9 12.9v12.9H45.2zm0 6.5c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H12.9C5.8 58.1 0 52.3 0 45.2s5.8-12.9 12.9-12.9h32.3z"
                  fill="#36c5f0"
                ></path>
                <path
                  d="M97 45.2c0-7.1 5.8-12.9 12.9-12.9s12.9 5.8 12.9 12.9-5.8 12.9-12.9 12.9H97V45.2zm-6.5 0c0 7.1-5.8 12.9-12.9 12.9s-12.9-5.8-12.9-12.9V12.9C64.7 5.8 70.5 0 77.6 0s12.9 5.8 12.9 12.9v32.3z"
                  fill="#2eb67d"
                ></path>
                <path
                  d="M77.6 97c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9-12.9-5.8-12.9-12.9V97h12.9zm0-6.5c-7.1 0-12.9-5.8-12.9-12.9s5.8-12.9 12.9-12.9h32.3c7.1 0 12.9 5.8 12.9 12.9s-5.8 12.9-12.9 12.9H77.6z"
                  fill="#ecb22e"
                ></path>
              </svg>
            </a>
            <Tooltip title={user?.[`name`]}>
              <IconButton onClick={handleOpenUserMenu}>
                <Avatar
                  alt={user?.[`name`][0]}
                  src="/static/images/avatar/2.jpg"
                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleAction}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
